<!--
 * @Author: ivan.ji
 * @Date: 2020-03-09 16:05:17
 * @LastEditors: fengzhongmei 996180799@qq.com
 * @LastEditTime: 2022-09-13 09:52:09
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div class="msg-pack card">
        <div class="title">{{$t('消息中心')}}
            <a class="more"
               @click="hasPermission('CF')&&$router.push('/mgt/msgs')">
                <i class="icon-arrow-under-o"></i>
            </a>
        </div>
        <ul class="msg-con"
            v-if="msgs.length">
            <li v-for="(msg, k) in msgs"
                @click="hasPermission('CF')&&$router.push('/mgt/msgs')"
                :key="k">
                <span class="tit"
                      style="cursor: pointer;"
                      :title="$t(msg.msgTitle)">{{$t(msg.msgTitle)}}</span>
                <span class="time">{{msg.sendDate}}</span>
            </li>
        </ul>
        <div v-else
             class="no-data">
            <noData></noData>
        </div>
    </div>
</template>
<script>
import noData from '@c/basic/nodata'
import API from '@/service/api'
export default {
    name: 'cloudproduct',
    components: {
        noData
    },
    data () {
        return {
            msgs: []
        }
    },
    mounted () {
        this.initData()
    },
    methods: {
        initData () {
            this.axios.get(this.urlFormat(API.GET_MSG_INFO, true), {
                params: {
                    readFlag: '02',
                    pagenum: 0,
                    pagesize: 10
                }
            }).then(res => {
                this.msgs = res.dataList
            })
        }
    }
}
</script>
<style lang="less" scoped>
.msg-pack {
    .title {
        display: flex;
        justify-content: space-between;
        .more {
            min-width: 50px;
            text-align: right;
            .icon-arrow-under-o {
                display: inline-block;
                transform: rotate(-90deg);
                color: #999999;
                font-size: 10px;
                font-weight: 600;
            }
        }
    }
    .msg-con {
        font-size: 12px;
        padding: 5px 10px;
        li {
            padding: 6px 5px;
            display: flex;
            justify-content: space-between;
            .tit {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .time {
                color: #999999;
                white-space: nowrap;
                margin-left: 10px;
            }
            &:hover {
                background-color: #f5f6f7;
            }
        }
    }
    .no-data {
        height: calc(~'100% - 40px');
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
